import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FaEllipsisH } from "react-icons/fa";
import { IconButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";

const defaultProps = {
    items: [],
    sx: {},
    buttonSx: {},
    size: "normal",
    disabled: false,
    color: "primary",
};

const DropdownMenu = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const renderMenuItem = (item, k) => {
        const renderItem = () => (
            <MenuItem
                onClick={() => {
                    handleClose();
                    item.onClick();
                }}
            >
                {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                <ListItemText>{item.text}</ListItemText>
            </MenuItem>
        );
        return ![null, undefined, ''].includes(item.title) ? (
            <Tooltip key={k} title={item.title}>
                {renderItem()}
            </Tooltip>
        ) : (
            renderItem()
        );
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                color={props.color}
                sx={{ minWidth: 45, ...props.buttonSx }}
                size={props.size}
                disabled={props.disabled}
            >
                <FaEllipsisH />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
                sx={props.sx}
            >
                {props.items.map((r, k) => (r.el ? r.el(k, handleClose) : renderMenuItem(r, k)))}
            </Menu>
        </>
    );
};

export default DropdownMenu;
